import ApplyToOldest from './ApplyToOldest';
import {
  oldestInvoicedataSel,
  oldestInvoiceDebitSel,
  oldestInvoiceCreditSel,
  selectcreditInvoicedataSel,
  creditInvoiceTotalElementsSel
} from 'src/store/modules/invoices';
import actions from 'src/store/modules/invoices/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';

const mapStateToprops = (state: any) => ({
  selectedOldestInvoices: oldestInvoicedataSel(state),
  totalDebit: oldestInvoiceDebitSel(state),
  totalCredit: oldestInvoiceCreditSel(state),
  totalSize: creditInvoiceTotalElementsSel(state),
  selectCreditInvoices: selectcreditInvoicedataSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getOldestInvoices: (pagination: IPaginationInvoice) =>
    dispatch(actions.getOldestInvoices(pagination)),
  getselectCredit: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getselectCredit(filters, pagination)),
  getCreditDebitSummary: (type: any) =>
    dispatch(actions.getCreditDebitSummary(type)),
  setSelectedInvoices: (invoices: any) =>
    dispatch(actions.setSelectedInvoices(invoices))
});

export default connect(
  mapStateToprops,
  mapDispatchToProps
)(withRouter(ApplyToOldest));
//   interface IApplyToOriginalProps {
//     getOldestInvoices(): void;
//   }
